module.exports = __webpack_public_path__ + "img/iconography-3.b8f4621d.jpg";